var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
import { observable, action, computed, makeObservable } from "mobx";
import translate from "../../../utilities/i18n/getTranslate";
import { k } from "../../../utilities/i18n";
export var conversationMessagesTags;
(function (conversationMessagesTags) {
    conversationMessagesTags["NO_ERRORS"] = "";
    conversationMessagesTags["UNEXPECTED"] = "unexpected";
    conversationMessagesTags["LOADING_PROBLEM"] = "loadingProblem";
})(conversationMessagesTags || (conversationMessagesTags = {}));
export var notificationsTypes;
(function (notificationsTypes) {
    notificationsTypes["ERROR"] = "error";
    notificationsTypes["INFO"] = "info";
    notificationsTypes["SUCCESS"] = "success";
    notificationsTypes["WARNING"] = "warning";
})(notificationsTypes || (notificationsTypes = {}));
var errorMessages = (_a = {},
    _a[conversationMessagesTags.NO_ERRORS] = "",
    _a[conversationMessagesTags.UNEXPECTED] = translate(k.InboxConversationNotFound),
    _a[conversationMessagesTags.LOADING_PROBLEM] = translate(k.InboxConversationMessagesLoadingProblem),
    _a);
var NotificationState = /** @class */ (function () {
    function NotificationState() {
        var _this = this;
        this.notifications = [];
        this.templateName = "";
        this.conversationList = "";
        this.conversationMessages = conversationMessagesTags.NO_ERRORS;
        this.id = 0;
        this.types = notificationsTypes;
        this.defaultNotificationValues = {
            id: 0,
            message: "",
            type: notificationsTypes.INFO,
            showCloseButton: true,
            timeoutToClose: 10,
            showCount: false,
            counter: 1,
            restartTimeCounter: false,
        };
        this.add = function (notification) {
            try {
                if (!notification.message)
                    throw new Error("Message is missing");
                _this.id++;
                notification.id = _this.id;
                if (notification.id) {
                    var notificationWithDefaults_1 = __assign(__assign(__assign({}, _this.defaultNotificationValues), notification), { timeoutToClose: notification.type === notificationsTypes.ERROR ||
                            (typeof notification.timeoutToClose === "number" &&
                                notification.timeoutToClose === 0)
                            ? 0
                            : notification.timeoutToClose
                                ? notification.timeoutToClose
                                : _this.defaultNotificationValues.timeoutToClose });
                    var indexIfAlreadyExist = _this.notifications.findIndex(function (notification) {
                        return notification.message === notificationWithDefaults_1.message &&
                            notification.type === notificationWithDefaults_1.type;
                    });
                    if (indexIfAlreadyExist !== -1) {
                        _this.notifications[indexIfAlreadyExist].counter++;
                        _this.notifications[indexIfAlreadyExist].timeoutToClose =
                            notificationWithDefaults_1.timeoutToClose;
                        _this.notifications[indexIfAlreadyExist].restartTimeCounter = true;
                    }
                    else {
                        _this.notifications.push(new Notification(notificationWithDefaults_1));
                    }
                }
            }
            catch (error) {
                console.log("Error adding notification:", error);
            }
        };
        this.remove = function (id) {
            var notificationToRemovePosition = _this.notifications.findIndex(function (notification) { return id === notification.id; });
            _this.notifications.splice(notificationToRemovePosition, 1);
        };
        makeObservable(this, {
            notifications: observable,
            templateName: observable,
            conversationList: observable,
            conversationMessages: observable,
            id: observable,
            errorMessageForMessages: computed,
            add: action,
            remove: action,
            clearPopup: action,
            clearAll: action,
        });
    }
    Object.defineProperty(NotificationState.prototype, "errorMessageForMessages", {
        get: function () {
            return errorMessages[this.conversationMessages];
        },
        enumerable: false,
        configurable: true
    });
    NotificationState.prototype.clearPopup = function () {
        this.templateName = "";
    };
    NotificationState.prototype.clearAll = function () {
        this.notifications = [];
        this.templateName = "";
        this.conversationList = "";
        this.conversationMessages = conversationMessagesTags.NO_ERRORS;
        this.id = 0;
        this.types = notificationsTypes;
    };
    return NotificationState;
}());
export { NotificationState };
var Notification = /** @class */ (function () {
    function Notification(notification) {
        this.id = notification.id;
        this.message = notification.message;
        this.type = notification.type;
        this.showCloseButton = notification.showCloseButton;
        this.timeoutToClose = notification.timeoutToClose;
        this.showCount = notification.showCount;
        this.counter = notification.counter;
        this.onClickAction = notification.onClickAction;
        this.restartTimeCounter = notification.restartTimeCounter;
        this.action = notification.action;
        makeObservable(this, {
            counter: observable,
            restartTimeCounter: observable,
        });
    }
    return Notification;
}());
var store = new NotificationState();
export default store;
//# sourceMappingURL=data:application/json;base64,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